import utils from 'utils/utils';
import appnexusTag from './appnexus-tag-builder';

const JwAdsConfig = function (stream) {
    this.stream = stream;
    this.config = {};
    this.params = [];
};

JwAdsConfig.prototype = {
    setParams(params) {
        this.params = params;
    },

    add(adSlotConfig, offset, adLabel) {
        // do not add tag when id is empty
        if (adSlotConfig) {
            this.config[adLabel + Math.floor(Math.random() * 100) + 1] = {
                offset: offset,
                tag: appnexusTag.getVmapTag(utils.merge(this.params, adSlotConfig))
            };
        }
    },

    getConfig() {
        return this.config;
    }
};

export default JwAdsConfig;
